<template>
    <modal name="modalKontainerUpload" :draggable="false" :scrollable="true" :height="'auto'">
        <div class="modal fade show " tabindex="-1" style="display: block;margin-top: 2%;" aria-modal="true"
            role="dialog">
            <div class="modal-dialog  modal-lg">
                <div class="modal-content">

                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel"> {{ $t("peti_kemas") }} </h5>

                        <button type="button" class="btn btn-default" @click.prevent="removeModals()"
                            aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>


                    <form class="forms-sample" @submit.prevent="submitData" method="POST" enctype="multipart/form-data">

                        <div class="modal-body">


                            <div class="mb-3">

                                <label for="defaultconfig" class="col-form-label required">File</label>

                                <input type="file" ref="file" class="form-control" :id="this.$dynamicId()"
                                    @change="handleFileUpload($event)" required />

                                <div v-if="errors.file">
                                    <div v-for="error in errors.file" :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i> {{ error }}
                                    </div>
                                </div>

                            </div>

                            <div class="mb-3">

                                <label for="defaultconfig" class="col-form-label required me-5">Template</label>

                                <button class="btn btn-success btn-xs" @click="downloadTemplate" type="button">
                                    <i class="mdi mdi-download"></i>
                                    {{ $t("downloadData") }} Template
                                </button>

                            </div>

                            <div v-if="tableResponse" class="row">
                            <div class="col-lg-12">

                                    <br>
                                    <br>
                            
                                <div class="table-responsive">
                                    <table class="table table-hover">
                                        <thead>
                                        <th>{{ $t('lineNo') }}</th>
                                        <th>{{ $t('statusTxt') }}</th>
                                        <th>{{ $t('messageTxt') }}</th>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(errorData, index) in errorsData" :key="index">
                                            <th>{{ errorData.lineNo }}</th>
                                            <th>{{ errorData.status }}</th>
                                            <th>{{ errorData.message }}</th>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
  
  
                        </div>

                        </div>


                        <div class="modal-footer justify-content-between">
                            <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">{{
        this.$t("close_txt") }}</button>

                            <button type="submit" class="btn btn-primary">
                                <div v-show="isLoading">
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    Loading...
                                </div>
                                <div v-show="!isLoading">
                                    <i class="link-icon mdi mdi-content-save"></i>
                                    {{ this.$t("save_change_txt") }}
                                </div>
                            </button>
                            
                        </div>

                    </form>

                </div>
            </div>
        </div>
    </modal>
</template>

<script>
export default {
    name: "modalKotainerUpload",
    props: {
        docId: { type: Number }
    },
    data() {
        return {
            isLoading:false,
            form_kemasan: [],
            errors: [],

            tableResponse:false,
            errorsData:[],
            file: '',

        }
    },
    methods: {
        handleFileUpload( event ){
            this.file = event.target.files[0];
        },
        downloadTemplate() {

            const baseURI = this.$settings.endPointCeisa + "v1/document/download-template-kontainer";

            var file_name = "template_dokumen_kontainer.xlsx";

            this.isLoading = true;
            return this.$http.get(
                baseURI,
                {
                    responseType: "blob",
                }
            ).then((response) => {

                this.isLoading = false;
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement("a");

                fileLink.href = fileURL;
                fileLink.setAttribute("download", file_name);
                document.body.appendChild(fileLink);
                fileLink.click();
                this.fade(false);
            }).catch((error) => {

                this.isLoading = false;

                if (error.code == "ECONNABORTED") {
                    this.error(this.$t("check_internet_connection_txt"));

                } else {


                    if (error.code == "ECONNABORTED") {

                        this.error(this.$t("check_internet_connection_txt"));

                    } else {

                        if (error.response) {
                            if (error.response.status === 422) {
                                this.errors = error.response.data.errors;
                                this.resultError(error.response.data.errors);
                            } else if (error.response.status === 401) {
                                this.logout();
                            } else if (error.response.status === 403) {
                                this.$router.push("/authorized-error");
                            } else if (error.response.status === 500) {
                                this.$router.push('/server-error');
                            } else {
                                this.$router.push('/page-not-found');
                            }
                        }

                    }

                }

            });

        },
        customSearch(option, label, search) {
            let temp = search.toLowerCase();
            return option.code.toLowerCase().indexOf(temp) > -1 ||
                option.name.toLowerCase().indexOf(temp) > -1
        },
        forceUpper(e, obj, prop) {
            const start = e.target.selectionStart
            e.target.value = e.target.value.toUpperCase()
            this.$set(obj, prop, e.target.value)
            e.target.setSelectionRange(start, start)
        },
        removeModals() {
            this.tableResponse=false;
            this.errorsData = [];
            this.$modal.hide('modalKontainerUpload');
        },
        submitData() {
            this.$swal({
            title: this.$t("areYouSure"),
            text: this.$t("yourData"),
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes!",
            }).then((result) => {
                if (result.value) {
                    
                    this.isLoading = true;
        
                    let formData = new FormData();
                    formData.append("file", this.file);
                
                    const baseURI  =  this.$settings.endPointCeisa+"v1/document/upload-document-kontainer/"+this.docId;
                    this.$http.post(baseURI,formData).then((response) => {
                        this.isLoading = false;
                        if(response.data.status === 200) {
                            this.errors = [];
                            this.tableResponse=true;
                            this.errorsData = response.data.datas;
                            this.$emit("setValue");
                        }else{
                        
                            this.errors = response.data.errors;
                            this.resultError(response.data.errors);
                        }
                    }).catch((error) => {

                        this.isLoading = false;
                        this.tableResponse=true;

                        if (error.code == "ECONNABORTED") {
                            this.error(this.$t("check_internet_connection_txt"));

                        } else {


                            if (error.code == "ECONNABORTED") {
                                
                                this.error(this.$t("check_internet_connection_txt"));

                            } else {

                                if (error.response) {
                                    if (error.response.status === 422) {
                                        this.errorsData = error.response.data.errors;
                                        this.errors      = error.response.data.errors;
                                        this.resultError(error.response.data.errors);
                                    } else if (error.response.status === 401) {
                                    this.logout();
                                    } else if (error.response.status === 403) {
                                    this.$router.push("/authorized-error");
                                    } else if (error.response.status === 500) {
                                    this.$router.push('/server-error');
                                    } else {
                                    this.$router.push('/page-not-found');
                                    }
                                }

                            }

                        }

                    });
                }
            });
        },
        logout() {

            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

                console.log(response);

            });

            this.$logoutUser();
            window.location.href = '/';
        },

        fade(sType) {
            this.isLoading = sType;
        },

        loading() {
            this.fade(true);
            setTimeout(() => {
                this.fade(false);
            }, 1000); // hide the message after 3 seconds
        },

        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                }
            }
        },

        success(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "success",
                title: kata,
            });
        },

        error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },

        removeField(index, fieldType) {
            fieldType.splice(index, 1);
        },
    },
}
</script>

<style></style>